import { defineStore } from "pinia"
import { markRaw } from "vue"

export type SetIndexCandle = {
  trade_date: string
  open: number
  high: number
  low: number
  close: number

  // 🔥 derived
  gain: number | null
  pivotLow: "LL" | "HL" | null
  pivotHigh: "HH" | "LH" | null
}

export type SetIndexHistResponse = {
  results: {
    trade_date: string
    open: number
    high: number
    low: number
    close: number
  }[]
}

export const useSetIndexStore = defineStore("setindex", {
  state: () => ({
    calendar: [] as string[],
    calendarReady: false,
    calendarLoadedAt: 0,

    setIndexCandles: [] as SetIndexCandle[],
  }),

  actions: {
    async fetchCalendar(limit = 300) {
      if (this.calendarReady) return

      const now = Date.now()

      const res: SetIndexHistResponse = await fetch(
        `https://stock-api.nextbar.trade/setindex/hist?limit=${limit}`
      ).then(r => r.json())

      const raw = res.results ?? []

      // เรียงเก่ → ใหม่ เพื่อคำนวณเทียบ previous day
      const sorted = [...raw].sort(
        (a, b) => a.trade_date.localeCompare(b.trade_date)
      )

      const candles: SetIndexCandle[] = []

      for (let i = 0; i < sorted.length; i++) {
        const cur = sorted[i]
        const prev = sorted[i - 1]

        const gain =
          prev && typeof prev.close === "number"
            ? Number((cur.close - prev.close).toFixed(2))
            : null

        const pivotLow =
          prev && typeof prev.low === "number"
            ? cur.low < prev.low
              ? "LL"
              : cur.low > prev.low
              ? "HL"
              : null
            : null

        const pivotHigh =
          prev && typeof prev.high === "number"
            ? cur.high > prev.high
              ? "HH"
              : cur.high < prev.high
              ? "LH"
              : null
            : null

        candles.push({
          ...cur,
          gain,
          pivotLow,
          pivotHigh,
        })
      }

      // calendar
      this.calendar = markRaw(
        candles.map(c => c.trade_date)
      ) as string[]

      this.calendarReady = true
      this.calendarLoadedAt = now

      // candles (พร้อม derived field)
      this.setIndexCandles = markRaw(candles)
    },

    reset() {
      this.calendar = []
      this.calendarReady = false
      this.calendarLoadedAt = 0
      this.setIndexCandles = []
    },
  },
})
